import { render, staticRenderFns } from "./quaDialog.vue?vue&type=template&id=60dd7c1d"
import script from "./quaDialog.vue?vue&type=script&lang=js"
export * from "./quaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports